import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers, withState } from 'recompose';
import lifecycle from 'recompose/lifecycle';
import { fullName } from '../../../common/helpers/users';
import Icon, { GLYPHS } from '../../../common/icon';
import { getBarbers, getDeletedBarbers } from '../../../main/barbers/actions';
import BarberAvatar from '../../../main/barbers/components/BarberAvatar';
import { getAll, getAllDeleted } from '../../../main/barbers/selector';
import { getActiveCashRegisterOpenDate } from '../../cashRegister/selectors';
import { t } from '../../../../modules/infra/i18n';

const BarbersList = props => (
  <div className="o-flexbox__item--flex-1 c-data-panel u-color-white u-p u-border-radius u-mr">
    <div>
      <span className="c-label-new">{t('register:barbers_list.title')}</span>
    </div>
    <input
      type="text"
      className="c-input c-input--white u-border-radius u-mv"
      value={props.filter}
      onChange={e => props.setFilter(e.target.value)}
    />
    <div className="c-barbers-list">
      {props.shopBarbers.map(barber => (
        <div className="c-barber" key={barber.id} onClick={props.toggleBarber(barber.id)}>
          <div className="o-flexbox o-flexbox--content-align-center">
            <span className="c-avatar u-mr">
              <BarberAvatar barber={barber} />
            </span>
            <span>{fullName(barber)}</span>
          </div>
          {
              props.selectedBarber === barber.id && (
                <Icon
                  glyph={GLYPHS.check}
                  className="c-checkmark"
                />
              )
            }
        </div>
        ))}
    </div>
  </div>
  );

BarbersList.propTypes = {
  shopBarbers: PropTypes.array.isRequired,
  filter: PropTypes.string.isRequired,
  setFilter: PropTypes.func.isRequired,
  selectedBarber: PropTypes.string.isRequired,
  toggleBarber: PropTypes.func.isRequired,

  // eslint-disable-next-line react/no-unused-prop-types
  onBarberSelect: PropTypes.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  shopId: PropTypes.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
  const allBarbers = getAll(state);
  const deletedBarbersWithTransactions = getAllDeleted(state).filter(
    ({ id }) => props.barberIdsWithTransactions.includes(id)
  );

  return ({
    openedAt: getActiveCashRegisterOpenDate(state),
    shopBarbers: [...allBarbers, ...deletedBarbersWithTransactions],
  });
};

const mapDispatchToProps = {
  getBarbers,
  getDeletedBarbers,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('filter', 'setFilter', ''),
  withHandlers({
    closeModal: props => () => {
      props.setFilter('');
      props.onClose();
    },
    toggleBarber: props => id => () => {
      if (props.isLoading) {
        return;
      }

      if (props.selectedBarber === id) {
        props.onBarberSelect(null);

        return;
      }

      props.onBarberSelect(id);
    },
  }),
  lifecycle({
    componentWillMount() {
      this.props.getBarbers(this.props.shopId);
      this.props.getDeletedBarbers(this.props.shopId);
    },
    componentWillUnmount() {
      this.props.getBarbers(this.props.shopId);
    },
    componentDidUpdate(prevProps) {
      if (prevProps.shopId !== this.props.shopId) {
        this.props.getBarbers(this.props.shopId);
      }

      if (prevProps.filter !== this.props.filter) {
        this.props.getBarbers(this.props.shopId, this.props.filter);

        this.props.onBarberSelect(null);
      }
    },
  })
)(BarbersList);
